define('services/routeService',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'viewModels/BreadcrumbNav',
    'services/embeddingService',
    'services/loggingService',
    'services/navHelper',
    'extensions/i18n/knockout.i18n'
], function (
    $,
    ko,
    _,
    BreadcrumbNav,
    embeddingService,
    LOG,
    navHelper,
    i18n
) {
    'use strict';

    // Constants

    var HELP_SYSTEM_URI = "https://help.genesys.cloud";

    // Route Service

    var routeService = {};

    // Previous Route

    var previousRoute = ko.observable(null);

    routeService.back = function(){
        if (previousRoute() && previousRoute() !== '#' && previousRoute() !== '#noop') {
            navHelper.navigateTo(previousRoute());
        } else {
            navHelper.navigateTo('#directory:');
        }
    };

    /**
     * Forces reevaluation of the route.  Sometimes IE does not dispatch hashChange native when a hash changes.  Sammy
     * has an internal polling interval for this - but if a hashchange is dispatched from another component - the poll
     * is removed and hash observation ceases.  This triggers hashChange in a way that allows Sammy to continue to
     * poll - and will trigger evaluation of the route.
     */
    routeService.triggerHashChange = function(){
        $(window).trigger('hashchange', [true]);
    };

    // Current Route

    routeService.route = ko.observable('#');
    routeService.route.subscribe(function (route) {
        LOG.info('Route Changed:', route);
        try {
            // If we are running in a child frame
            if(window.parent !== window && routeService.pageInfo()) {
                var title = i18n.renderString(routeService.pageInfo()._label);
                var origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                window.parent.postMessage({
                    type: 'content:route:changed',
                    data: { hash: route, title: title }
                }, origin);
            }
        }catch(error){
            LOG.error(error, route);
        }
    });

    // Update previous route on route change

    routeService.route.subscribe(function (oldRoute) {
        previousRoute(oldRoute);
    }, null, "beforeChange");

    routeService.pathParameters = ko.observable();
    routeService.pageInfo = ko.observable();

    routeService.segments = ko.computed(function () {
        if (routeService.route()) {

            return routeService.route()
                    .replace(/^#\/?/, '')
                    .replace(/\/$/, '')
                    .split('/');
        }
    });

    // Routes and URLs for contextual help link.  This is set
    // on Sammy's route definition.

    var helpRoute = ko.observable('');

    routeService.getHelpURLForRoute = function (pageUrl) {
        var locale = i18n.getLocale();

        if(pageUrl){
            var currentHash = pageUrl,
                hashRegex = /^#/,
                hash = currentHash.replace(hashRegex,'');

            return HELP_SYSTEM_URI + "/redirect/" + locale + "/" + hash;
        } else {
            return HELP_SYSTEM_URI + "/redirect/" + locale + "/";
        }
    };
    routeService.helpURL = ko.computed({
        read: function(){
            return helpRoute();
        },
        write: function(value){
            helpRoute(routeService.getHelpURLForRoute(value));
            embeddingService.notifyHelpURL(helpRoute());
        }
    });



    var breadcrumbSegments = ko.computed(function () {

        var breadcrumbs;
        var pageInfo = routeService.pageInfo(),
            route = routeService.route();
        if (pageInfo && route) {
            breadcrumbs = [];
            addBreadcrumbRecursive(breadcrumbs, pageInfo);
        }
        return breadcrumbs;
    });

    //public nav data observable so view models can set data (label data for the breadcrumbs to use)
    routeService.breadcrumbsNavData = ko.observable();

    //private observable and public computed so view models can get the breadcrumbs nav view model
    var breadcrumbsNavViewModel = ko.observable();
    routeService.breadcrumbsNav = ko.computed(function() {
        //dispose of any previous breadcrumb viewmodel before creating a new one
        if(breadcrumbsNavViewModel()) {
            breadcrumbsNavViewModel().dispose();
            breadcrumbsNavViewModel(null);
        }
        breadcrumbsNavViewModel(new BreadcrumbNav(breadcrumbSegments(), routeService.breadcrumbsNavData()));

        breadcrumbsNavViewModel().getAllEmbedded();
        return breadcrumbsNavViewModel();
    });

    //computed for detecting breadcrumb change to change document title
    ko.computed(function () {
        var documentTitle = '',
            navViewModel = breadcrumbsNavViewModel(),
            route = routeService.route();
        if(!i18n.keyExists('siteMap.defaultTitle')) {
            return; //bootstrapping still in progress
        }
        if(navViewModel && route) {
            var current = navViewModel.getCurrent(),
                previous = navViewModel.getPrevious(),
                separator = i18n.renderString('siteMap.defaultTitleSeparator');
            if(current) {
                documentTitle += i18n.renderString(current.label, current.labelData) + separator;
            }
            if(previous) {
                documentTitle += i18n.renderString(previous.label, previous.labelData) + separator;
            }
        }
        documentTitle += i18n.renderString('siteMap.defaultTitle');
        // don't assign to document.title until it's fully built so trailing spaces aren't lost
        document.title = documentTitle;
    });

    /*
     * Utility Functions
     */

    var addBreadcrumbRecursive = function (breadCrumbList, pageInfo) {
        var hash;
        if (!pageInfo.isStaticBreadcrumb) {
            hash = createHash(pageInfo._hash, routeService.pathParameters());
        }

        var breadcrumb = {
            hash: hash,
            label: pageInfo._label,
            key: pageInfo._token
        };

        breadCrumbList.unshift(breadcrumb);

        if (pageInfo._parent) {
            addBreadcrumbRecursive(breadCrumbList, pageInfo._parent);
        }
    };

    var createHash = function (hash, parameters) {
        _.each(parameters, function (value, param) {
            var paramRegex = new RegExp(':' + param + '(/.*)?$');
            if(!hash) {
                LOG.warn('Route service was unable to compute the hash. You may have a sub route segment that does not have a valid pageInfo hash for which to determine the title. The breadcrumb for this segment will not be linkable.');
                return;
            }
            hash = hash.replace(paramRegex, value + '$1');
        });
        return hash;
    };

    return routeService;
});

